// extracted by mini-css-extract-plugin
export default {"error":"Paypal_error__b-FRe"};